import { render, staticRenderFns } from "./otherMessages.vue?vue&type=template&id=31b09f9e&scoped=true&"
import script from "./otherMessages.vue?vue&type=script&lang=js&"
export * from "./otherMessages.vue?vue&type=script&lang=js&"
import style0 from "./otherMessages.vue?vue&type=style&index=0&id=31b09f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b09f9e",
  null
  
)

export default component.exports